import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SDUIOnClickHandler } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/SDUIOnClickHandler/SDUIOnClickHandler";
import { SDUIBackgroundIcon } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/BackgroundIcon/SDUIBackgroundIcon";
import { SDUIConstrainedWidthAnnouncementBannerRenderer, SDUIDefaultAnnouncementBannerRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/__internal__/AnnouncementBannerRenderer/SDUIAnnouncementBannerRenderer";
import { SDUIImageBannerV2Renderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/__internal__/ImageBannerV2/SDUIImageBannerV2Renderer";
import { SDUIDefaultImageTextBannerRenderer, SDUIImageTextBannerRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/__internal__/ImageTextBanner/SDUIImageTextBannerRenderer";
import { SDUIVerticalModalTextImageBannerRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/__internal__/VerticalModalTextImageBanner/SDUIVerticalModalTextImageBannerRenderer";
import { BannerVariant } from "@faire/web-api--source/indigofair/data/BannerVariant";
import React from "react";
export var SDUIBannerRenderer = function(param) {
    var component = param.component, loggingData = param.loggingData, renderBehaviour = param.renderBehaviour, onClickClientDismissHandler = param.onClickClientDismissHandler;
    var _bannerComponent_style;
    var bannerComponent = component.banner_component;
    if (!bannerComponent || ((_bannerComponent_style = bannerComponent.style) === null || _bannerComponent_style === void 0 ? void 0 : _bannerComponent_style.variant) === undefined) {
        return null;
    }
    var SDUIBannerVariantRenderer = SDUIBannerVariantRendererMap[bannerComponent.style.variant];
    if (SDUIBannerVariantRenderer === undefined) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(SDUIOnClickHandler, {
        onClickActions: bannerComponent.on_click,
        loggingData: loggingData,
        componentStyle: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ _jsx(SDUIBannerVariantRenderer, {
                bannerComponent: bannerComponent,
                loggingData: loggingData,
                renderBehaviour: renderBehaviour,
                onClickClientDismissHandler: onClickClientDismissHandler
            }),
            /*#__PURE__*/ _jsx(SDUIBackgroundIcon, {
                backgroundIcon: bannerComponent.background_icon,
                responsiveBackgroundIcon: bannerComponent.responsive_background_icon
            })
        ]
    });
};
var _obj;
var SDUIBannerVariantRendererMap = (_obj = {}, _define_property(_obj, BannerVariant.TEXT_IMAGE_BANNER, SDUIImageTextBannerRenderer), _define_property(_obj, BannerVariant.DEFAULT_IMAGE_TEXT_BANNER, SDUIDefaultImageTextBannerRenderer), _define_property(_obj, BannerVariant.IMAGE_BANNER_V2, SDUIImageBannerV2Renderer), _define_property(_obj, BannerVariant.IMAGE_BANNER, SDUIImageBannerV2Renderer), _define_property(_obj, BannerVariant.ANNOUNCEMENT_BANNER, SDUIDefaultAnnouncementBannerRenderer), _define_property(_obj, BannerVariant.ANNOUNCEMENT_BANNER_CONTENT_WIDTH_CONSTRAINED, SDUIConstrainedWidthAnnouncementBannerRenderer), _define_property(_obj, BannerVariant.VERTICAL_MODAL_TEXT_IMAGE_BANNER, SDUIVerticalModalTextImageBannerRenderer), _obj);
